import md5 from 'md5'

import { WitaConnector } from '@/services/repository/connector'

import { AuthRepositoryProps } from './AuthRepository.d'

const ROOT_URL = '/authentication/user'

export const AuthRepository = {
  Login: async function (params: AuthRepositoryProps.Login.Params) {
    const url = ROOT_URL + `/login`

    const data = {
      username: params.username,
      password: md5(params.password),
    }

    return await WitaConnector.post<AuthRepositoryProps.Login.Response>(
      url,
      data,
    )
  },

  ValidateToken: async function (
    params: AuthRepositoryProps.ValidateToken.Params,
  ) {
    const url = ROOT_URL + `/token`
    return await WitaConnector.post<AuthRepositoryProps.ValidateToken.Response>(
      url,
      params,
    )
  },
}
